import React, { useState } from 'react'
import { AutoComplete, Spin } from 'antd'
import { useQuery } from 'urql'

const UsersQuery = `
  query ($email: String!) {
    search_user(email: $email) {
      id_usuario,
      email
    }
  }
`

export function UserSelector({
  onChange,
  placeholder = 'Search a user',
  defaultEmail = '',
  disabled,
  style,
}) {
  const [lastSelected, setLastSelected] = useState('')
  const [email, setEmail] = useState(defaultEmail)
  const [res] = useQuery({
    query: UsersQuery,
    variables: { email },
    pause: email.length < 2 || email === lastSelected,
  })

  const suggestions = (res.data?.search_user || []).filter((v) => v)

  return (
    <AutoComplete
      size="medium"
      filterOption={false}
      value={email}
      disabled={disabled}
      key={lastSelected.current}
      onBlur={() => setEmail(lastSelected || defaultEmail)}
      notFoundContent={res.fetching ? <Spin size="small" /> : null}
      placeholder={placeholder}
      onSearch={setEmail}
      style={style || { width: '100%' }}
      onSelect={(selectedEmail) => {
        const user = suggestions.find((s) => s.email === selectedEmail)
        setLastSelected(selectedEmail)
        setEmail(selectedEmail)
        if (typeof onChange === 'function') onChange(user)
      }}
    >
      {suggestions.map((s) => (
        <AutoComplete.Option key={s.email} value={s.email}>
          {s.email}
        </AutoComplete.Option>
      ))}
    </AutoComplete>
  )
}
